import { createAction, props } from '@ngrx/store';
import { FeatureFlag } from '../models/feature-flag.model';

export enum FeatureFlagActions {
    LoadFeatureFlags = '[Feature Flags] Load',
    LoadFeatureFlagsSuccess = '[Feature Flags] Load Success',
    LoadFeatureFlagsFailure = '[Feature Flags] Load Failure',
}

export const loadFeatureFlags = createAction(FeatureFlagActions.LoadFeatureFlags);
export const loadFeatureFlagsSuccess = createAction(FeatureFlagActions.LoadFeatureFlagsSuccess, props<{ flags: FeatureFlag[] }>());
export const loadFeatureFlagsFailure = createAction(FeatureFlagActions.LoadFeatureFlagsFailure, props<{ error: any }>());
